import React, { useEffect, useRef, useState } from 'react';
import { BrowserQRCodeReader, IScannerControls } from '@zxing/browser';
import { Box, Button, Container, Stack } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import MODAL_TABLE from '../../../../main_components/modal/modal_Table';
import { bussines_partnert_put_qr, bussines_partnert_put } from '../../../../services/businesspartners/businesspartners';
import { supplier_get } from '../../../../services/expenses/expense';
import { BUSSINES_PARTNER } from '../interface/interface';
import { verifyToken } from '../../../../main_components/tokens/verifyToken';

// Tipado opcional para TypeScript (evita errores al usar BarcodeDetector)
declare global {
  interface Window {
    BarcodeDetector?: any;
  }
}

interface CustomTableProps {
  data: any;
}

const CustomQRInvoice: React.FC<CustomTableProps> = ({ data }) => {

  console.log(data)
  const videoRef = useRef<HTMLVideoElement>(null);
  const codeReaderRef = useRef<BrowserQRCodeReader | null>(null);
  const controlsRef = useRef<IScannerControls | null>(null);
  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);

  const [modalT, setModalT] = useState(false);
  const [messgeNotFound, setMessgeNotFound] = useState("");
  const hasScannedRef = useRef(false);

  const [enableButton, setEnableButton] = useState(false);
  const [enableButtonNotFound, setEnableButtonNotFound] = useState(false);
  const [scanning, setScanning] = useState(true);

  const [rfc, setrfc] = useState("");
  const [type_Suplier, setType_suplier] = useState(false);
  const [update_type, setupdate_type] = useState(false);
  const [dataResponse, setdataResponse] = useState<any>({});

  const navigate = useNavigate();

  // ===== Helpers de cámara =====
  const getStream = async () => {
    return navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: { ideal: 'environment' },
        width: { ideal: 1280 },
        height: { ideal: 720 },
      },
      audio: false,
    });
  };

  const stopAll = () => {
    try { controlsRef.current?.stop(); } catch { }
    controlsRef.current = null;

    const stream = (videoRef.current?.srcObject as MediaStream) || mediaStream || null;
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setMediaStream(null);
  };

  // ===== Rama nativa con BarcodeDetector =====
  const nativeCancelRef = useRef<() => void>(() => { });
  const startNativeDetector = async () => {
    if (!videoRef.current) return;

    const stream = await getStream();
    videoRef.current.srcObject = stream;
    await videoRef.current.play();
    setMediaStream(stream);

    const detector = new window.BarcodeDetector!({ formats: ['qr_code'] });

    let stopped = false;
    nativeCancelRef.current = () => { stopped = true; };

    const tick = async () => {
      if (stopped) return;
      try {
        // Algunos navegadores permiten pasar directamente el elemento <video>
        const codes = await detector.detect(videoRef.current!);
        if (codes && codes.length) {
          if (hasScannedRef.current) return;
          hasScannedRef.current = true;

          stopped = true;
          stopAll();
          await handle_response_url(codes[0].rawValue);
          return;
        }
      } catch {
        // ignora frames sin detección
      }
      requestAnimationFrame(tick);
    };
    tick();
  };

  // ===== Fallback ZXing =====
  const startZXing = async () => {
    if (!videoRef.current) return;
    const codeReader = new BrowserQRCodeReader();
    codeReaderRef.current = codeReader;

    await codeReader.decodeFromVideoDevice(
      undefined,
      videoRef.current,
      async (result, error, controls) => {
        if (!controlsRef.current) controlsRef.current = controls;

        if (result) {
          if (hasScannedRef.current) return;
          hasScannedRef.current = true;

          try { controlsRef.current?.stop(); } catch { }
          const stream = (videoRef.current?.srcObject as MediaStream) || mediaStream || null;
          if (stream) { stream.getTracks().forEach(t => t.stop()); }
          if (videoRef.current) videoRef.current.srcObject = null;
          setMediaStream(null);

          await handle_response_url(result.getText());
        }
      }
    );

    // captura el stream que ZXing adjuntó al video (puede tardar un frame)
    setTimeout(() => {
      if (videoRef.current?.srcObject) {
        setMediaStream(videoRef.current.srcObject as MediaStream);
      }
    }, 300);
  };

  const startScanner = async () => {
    if (!videoRef.current) return;
    hasScannedRef.current = false;

    try {
      if ('BarcodeDetector' in window) {
        await startNativeDetector();
      } else {
        await startZXing();
      }
    } catch (err) {
      console.error("Error iniciando escáner:", err);
      // Como último recurso, intenta ZXing
      try { await startZXing(); } catch (e) { console.error(e); }
    }
  };

  // =================== Tu lógica de negocio (igual que la tuya) ===================

  const handle_response_url = async (url: string) => {
    setModalT(true);
    setType_suplier(false);
    setupdate_type(false);
    try {
      const response = await bussines_partnert_put_qr({ url });
      console.log('Respuesta del servidor:', response);
      setMessgeNotFound("El socio de negocios fue actualizado correctamente en el sistema.");
      validar_rfc(url);
    } catch (error: any) {
      console.log(error);
      if (error.status === 404 && error.response?.data) {
        const data = error.response.data;
        const bp = data.business_partner || {};
        const addr = data.address || {};

        const filledObject = {
          code: "",
          business_partner: bp.business_partner ?? null,
          rfc: bp.rfc ?? null,
          paymethod: "01",
          allow_invoicing: false,
          name: bp.name ?? null,
          force_code: false,
          first_last_name: bp.first_last_name ?? null,
          second_last_name: bp.second_last_name ?? null,
          capital_regime: bp.capital_regime ?? null,
          cfdi_use: "G03",
          tax_residence: null,
          num_reg_id_trib: null,
          metodo_pago: "PUE",
          tax_regime: bp.tax_regime ?? "616",
          email: bp.email ?? null,
          enable: true,
          person_type: (bp.rfc?.length === 12 ? "MORAL" : "FISICA"),
          zip_code: addr.zip_code ?? null,
          street: addr.street ?? null,
          city: addr.city ?? null,
          outdoor_number: addr.outdoor_number ?? null,
          inside_number: addr.inside_number ?? null,
          state: addr.state ?? "VERACRUZ DE IGNACIO DE LA LLAVE",
          reference: null,
          outer_code: null,
          account_number: null,
          id_accounting_account_fk: null,
          name_accounting_account: null,
          code_accounting_account: null,
          address_type: "FISCAL",
          country: "MÉXICO",
          town: null,
          subsidiary: "MATRIZ",
          neighborhood: addr.neighborhood ?? null,
          partner_type: "PROPIO",
          credit_days: null,
          business_partner_type: "CLIENTE",
        };

        setdataResponse(filledObject);
        setMessgeNotFound(data.message);
        setEnableButtonNotFound(true);
        setEnableButton(false)
      }
    } finally {
      setEnableButton(true);
      setModalT(false);
      stopAll();
    }
  };

  const validar_rfc = (url: string) => {
    try {
      const params = new URL(url).searchParams;
      const d3 = params.get("D3");
      const r = d3?.split("_")[1];
      if (r) {
        setrfc(r);
        const data_bussiness_rfc = data.filter((item: any) => item.rfc === r);
        setType_suplier(data_bussiness_rfc.length === 0);
      } else {
        console.log("RFC inválido o no definido");
      }
    } catch {
      console.log("URL inválida");
    }
  };

  const handleBussinesPartner = async (event?: React.SyntheticEvent): Promise<void> => {
    event?.preventDefault();
    setModalT(true);
    const isTokenValid = await verifyToken();
    if (!isTokenValid) {
      setTimeout(() => { handleBussinesPartner(); }, 1000);
      return;
    }
    try {
      const list = await fetchBussinesPartner();
      const data_supp = list.filter((item: any) => item.rfc === rfc);
      console.log(data_supp);
      if (data_supp && data_supp.length) {
        update_supplier(data_supp);
      } else {
        setModalT(false);
      }
    } catch {
      setModalT(false);
    }
  };

  const update_supplier = async (data_supp: any) => {
    try {
      const supp = data_supp[0];
      const dat = {
        "business_partner": {
          "business_partner": supp.business_partner,
          "rfc": supp.rfc,
          "business_partner_type": "AMBOS",
          "enable": supp.enable
        },
        "address": {}
      };
      const response = await bussines_partnert_put(dat, supp.id);
      console.log(response);
      setModalT(false);
      setType_suplier(false);
      setupdate_type(true);
    } catch (err) {
      console.log(err);
      setModalT(false);
    }
  };

  const fetchBussinesPartner = async (): Promise<BUSSINES_PARTNER[]> => {
    try {
      const rawResponse = await supplier_get();
      const payload = rawResponse?.data;
      const businessPartners: BUSSINES_PARTNER[] = Array.isArray(payload)
        ? payload
        : payload?.business_partner ?? [];
      return businessPartners;
    } catch (error) {
      console.error("Error al obtener los datos de paginación:", error);
      setModalT(false);
      return [];
    }
  };

  // Reemplaza tu handle_redirect_page por esto:
  const handle_redirect_page = () => {
    // 1) Cierra el modal actual (el que contiene el componente QR)
    window.dispatchEvent(new CustomEvent('bp:update-and-close', { detail: { refresh: false } }));

    // 2) Abre el formulario de creación con la data del QR (siguiente tick)
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent('bp:open-create-from-qr', { detail: { data: dataResponse } })
      );
    }, 0);
  };



  // ⬇️ Nuevo handler (sustituye a handle_reload_page)
  const handle_update_and_close = () => {
    // apaga la cámara y libera recursos
    stopAll();

    // dispara un evento para que ModernInvoiceForm cierre y reconsulte socios
    window.dispatchEvent(new CustomEvent('bp:update-and-close', { detail: { refresh: true } }));
  };

  // ===== Ciclo de vida =====
  useEffect(() => {
    if (scanning) startScanner();
    return () => {
      // cancela nativo si quedó activo
      try { nativeCancelRef.current(); } catch { }
      stopAll();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scanning]);

  // Reanuda si se vuelve desde el cache del navegador
  useEffect(() => {
    const onPageShow = (e: PageTransitionEvent) => {
      if ((e as any).persisted) {
        stopAll();
        setScanning(true);
      }
    };
    const onVisibility = () => {
      if (document.hidden) {
        stopAll();
      }
    };
    window.addEventListener('pageshow', onPageShow as any);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      window.removeEventListener('pageshow', onPageShow as any);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return (
    <Container maxWidth="sm">
      <MODAL_TABLE open={false} message={''} message2={''} modalGeneral={false} modalT={modalT} />

      <Stack spacing={2} sx={{ py: 2 }}>
        <Box
          sx={{
            position: 'relative',
            border: '2px solid #e0e0e0',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          {messgeNotFound === "" ? (
            <video
              ref={videoRef}
              playsInline // importante para iOS
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              muted
              autoPlay
            />
          ) : <div></div>}
        </Box>

        <Stack direction="column" spacing={2}>
          <p>{messgeNotFound}</p>

          {type_Suplier === true && (
            <div style={{ color: "black", textAlign: "justify", backgroundColor: "#f9e79aff", padding: "7px" }}>
              <p><b>Nota:</b> Actualmente, este socio de negocios está registrado como proveedor. <br />
                ¿Desea actualizar el tipo de socio a <b>cliente/proveedor</b>?
              </p>
              <button
                style={{ width: "100%", borderRadius: "5px", backgroundColor: "#ab8919ff" }}
                onClick={() => { handleBussinesPartner(); }}
              >
                ACTUALIZAR TIPO DE SOCIO
              </button>
            </div>
          )}

          {update_type === true && (
            <div style={{ color: "black", textAlign: "justify", backgroundColor: "#a2f99aff", padding: "7px" }}>
              Se ha actualizado correctamente el tipo de socio.
            </div>
          )}

          {enableButtonNotFound && (
            <Button
              fullWidth
              size="large"
              variant="contained"
              sx={{ bgcolor: '#5B21B6', '&:hover': { bgcolor: '#4C1D95' } }}
              onClick={handle_redirect_page}
            >
              REGISTRAR NUEVO SOCIO
            </Button>
          )}

          {enableButton && (
            <Button
              fullWidth
              size="large"
              variant="contained"
              sx={{ bgcolor: '#059669', '&:hover': { bgcolor: '#047857' } }}
              onClick={handle_update_and_close}
            >
              ACTUALIZAR INFORMACIÓN DEL FORMULARIO            </Button>
          )}
        </Stack>
      </Stack>
    </Container>
  );
};

export default CustomQRInvoice;
